<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <div class="row">
              <div class="col-5">
                <h5>Eventos</h5>
              </div>
              <div class="col-7">
                <div style="text-align: right">
                  <router-link to="/cadastrar-evento">
                    <button id="btn_new_user" type="button">Novo Evento</button>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead>
                  <tr style="background-color: rgb(56, 56, 56)">
                    <th scope="col">Código</th>
                    <th scope="col">Título</th>
                    <th scope="col">Data</th>
                    <th scope="col">Status</th>
                    <th scope="col">Ação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="evento in state.eventos" :key="evento.id" :value="evento.id">
                    <td scope="row">{{ evento.id }}</td>
                    <td>{{ evento.titulo }}</td>
                    <td>{{ evento.data_evento }}</td>
                    <td>{{ evento.status }}</td>
                    <td>
                      <router-link :to="{
                        name: 'AlterarEvento',
                        params: { id: evento.id },
                      }">
                        <button title="Alterar" type="button" class="btn btn-primary">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                            class="bi bi-pencil-fill" viewBox="0 0 16 16">
                            <path
                              d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708l-3-3zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207l6.5-6.5zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.499.499 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11l.178-.178z" />
                          </svg>
                        </button>
                      </router-link>
                      <button @click="deletar(evento.id)" title="Deletar" type="button" class="btn btn-danger">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                          class="bi bi-trash-fill" viewBox="0 0 16 16">
                          <path
                            d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                        </svg>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onMounted, reactive } from "vue";
import services from "../../services";
import { useStorage } from "vue3-storage";
export default {
  setup() {
    const storage = useStorage();
    var token = storage.getStorageSync("token");
    const state = reactive({
      eventos: [],
    });
    onMounted(() => {
      fetchEventos();
    });
    async function fetchEventos() {
      try {
        const { data } = await services.eventos.getAll({ token });
        console.log(data);
        state.eventos = data;
      } catch (error) {
        console.log(error);
      }
    }

    async function deletar(id) {
      if (confirm("Deseja deletar este evento?")) {
        try {
          state.isLoading = true;
          const { data } = await services.eventos.delete({
            id: id,
            token,
          });
          console.log(data.status);
          if (data.status != 200) {
            alert("Erro ao deletar evento!.");
          } else {
            fetchEventos();
          }
        } catch (error) {
          console.log(error);
        }
      }
    }
    return {
      state,
      deletar,
    };
  },
};
</script>
<style scoped>
h5 {
  color: #000;
}

tr {
  text-align: center;
}

th {
  color: #fff;
  border-bottom: solid 2px #000 !important;
}

td {
  border-bottom: solid 1px #000 !important;
  color: #000;
}

.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}

.btn {
  transform: none !important;
  margin-right: 5px;
  margin-bottom: 0;
  padding: 10px;
  width: 40px;
}

#btn_new_user {
  color: #000;
  font-weight: 600;
  padding: 5px;
  border: solid 2px #000;
  border-radius: 5px;
  background-color: rgb(152, 152, 152);
  transition: 0.2s;
}

#btn_new_user:hover {
  background-color: rgb(210, 209, 209);
}

.table-hover>tbody>tr:hover>* {
  color: rgb(0, 0, 0);
  background-color: rgb(225, 225, 225);
}
</style>
